import styles from './index.module.sass';
import { PATHS } from 'config';
import appService3 from 'images/app-service_3.png';
import { Link } from 'react-router-dom';
import amplitudeService from 'service/amplitude';
import { useEffect } from 'react';

const AppServices = () => {
  const servicesList = [
    {
      src: appService3,
      link: PATHS.AUTO_DETAILING,
      eventName: 'App sidebar 服務介紹_愛車服務_click',
    },
  ];

  useEffect(() => {
    amplitudeService.track('App sidebar 服務介紹_pageview');
  }, []);

  return (
    <div className={styles['app-services']}>
      <h1>
        探索車麻吉
        <br />
        更多行車服務
      </h1>
      {servicesList.map(item => {
        return (
          <Link
            to={item.link}
            onClick={() => {
              amplitudeService.track(item.eventName);
            }}
          >
            <img src={item.src} alt="service" />
          </Link>
        );
      })}
    </div>
  );
};

export default AppServices;
